import { gql } from '@apollo/client';

export const USER_PROFILES = gql`
  query getUserPreferences($pref: UserPreferencesPattern!) {
    getUserPreferences(pref: $pref) {
      app
      isDefault
      isPinned
      isPublished
      name
      order
      path
      value
      key
      version
      createdTS
      lastPublishedTS
      updatedTS
      userName
      regions
      roles
    }
  }
`;

export const USER_PROFILE_UPSERT = gql`
  mutation upsertUserPreference($pref: UserPreferenceInput!) {
    upsertUserPreference(pref: $pref) {
      app
      isDefault
      isPinned
      name
      order
      path
      value
      key
    }
  }
`;

export const USER_PROFILE_DELETE = gql`
  mutation deleteUserPreference($pref: UserPreferenceIdListReturn!) {
    deleteUserPreference(pref: $pref) {
      app
      createdTS
      isDefault
      name
      order
      path
      updatedTS
      value
      key
    }
  }
`;

export const USER_PROFILE_REORDER = gql`
  mutation updateUserPreferenceOrder($pref: UserPreferenceOrderInput!) {
    updateUserPreferenceOrder(pref: $pref) {
      app
      createdTS
      isDefault
      name
      order
      path
      updatedTS
      value
      key
    }
  }
`;

export const USER_PROFILE_PUBLISH = gql`
  mutation publishUserPreference($pref: PublishUserPreferenceInput!) {
    publishUserPreference(pref: $pref) {
      app
      name
      path
      value
      key
      userName
      roles
      regions
      createdTS
      updatedTS
    }
  }
`;
